import '../../../layout/project-flow.scss';

import { Box, Button, Paper } from '@mui/material';
import { FC, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Loading from '../../../components/Loading';
import PageTitle from '../../../components/PageTitle';
import { useLayout } from '../../../context/LayoutContext';
import { loadFlowStepData, StepDataResponse } from './_utils/datasources';
import { FlowActions, useProjectFlowReducer } from './_utils/reducer';
import ProjectConfiguration from './ProjectConfiguration/ProjectConfiguration';

const ProjectFlow: FC<{}> = () => {
  const [state, dispatch] = useProjectFlowReducer();
  const { setPageTitle } = useLayout();
  const { loading, project } = state;
  const history = useNavigate();

  const { idProject: projectId = '' } = useParams<{ idProject: string }>();

  // set initial values for back/next url
  const prevIsDisabled = loading;
  // process step change
  const changeStep = useCallback<(url: string) => void>(
    (url) => {
      if (url) {
        dispatch({ type: FlowActions.setLoading, loading: true });
        history(url);
      }
    },
    [history, dispatch],
  );

  // callback to initialize step data
  const initializeStepData = useCallback(
    (routeProjectId: string): void => {
      dispatch({ type: FlowActions.setLoading, loading: true });
      dispatch({ type: FlowActions.loadProject, project: null });

      loadFlowStepData(routeProjectId).then((result: StepDataResponse) => {
        if (result?.project) {
          dispatch({
            type: FlowActions.loadProject,
            project: result.project,
          });
        }

        dispatch({ type: FlowActions.setLoading, loading: false });
      });
    },
    [dispatch],
  );

  // initialize phase, project, runs when route is reached
  useEffect(() => {
    if (projectId) {
      initializeStepData(projectId);
    }
  }, [projectId, initializeStepData]);

  useEffect(() => {
    setPageTitle(`Project ${projectId}`);

    return () => {
      setPageTitle('');
    };
  }, [setPageTitle, projectId]);

  return (
    <>
      <PageTitle title={`Project ${projectId}`} />
      <Box className="ProjectFlow__root">
        <Box>
          {!project ? (
            <Loading />
          ) : (
            <ProjectConfiguration
              stepTitle="Project Configuration"
              stepDescription=""
              key="configuration"
              project={project || null}
              dispatch={dispatch}
            />
          )}
        </Box>
        <Paper className="ProjectFlow__footerActionsBar">
          <Button
            data-id-cypress="projectFlowBack"
            disabled={prevIsDisabled}
            onClick={() => changeStep('/projects')}
            className="ProjectFlow__backButton"
          >
            Back
          </Button>
          {state.applyButton}
        </Paper>
      </Box>
      <Box mt={10} />
    </>
  );
};

export default ProjectFlow;
